import { useState } from 'react';
import { compose } from 'ramda';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import withNotEnoughFundsDialog from 'components/hoc/withNotEnoughFundsDialog';
import withSignInDialog from 'components/hoc/withSignInDialog';
import withNotification from 'components/hoc/withNotification';
import generateQuantumJob from 'api/services/generateQuantumJob';
import { auth, useAuthState } from 'api/services/firebase';
import useAccountStore from 'store/accountStore';
import usePermissions from 'hooks/usePermissions';
import { isInQuantumWindow } from 'utils/time';

const RedirectToBilling = ({ redirect }) => (
  <Button onClick={() => redirect('/billing')}>
    <u>Go to Billing</u>
  </Button>
);

const SampleQuantumJobButton = ({
  redirect,
  openNotEnoughFundsDialog,
  showErrorNotification,
  openSignInDialog,
}) => {
  const [isJobSubmitting, setIsJobSubmitting] = useState(false);
  const { hasPermission } = usePermissions();
  const [user] = useAuthState(auth);
  const { promoStatus } = useAccountStore(
    (state) => ({
      promoStatus: state.activeAccount.promoStatus,
    }),
  );

  const handleClick = async () => {
    try {
      if (!user) {
        openSignInDialog({
          hint: 'You have to be logged in to run quantum jobs',
        });
        return;
      }

      setIsJobSubmitting(true);

      const data = await generateQuantumJob({
        job_name: 'Quantum Coin',
        circuit: 'sample_qpu',
        device: 'quantum',
        estimateOnly: false,
        asynchronous: true,
      });

      setIsJobSubmitting(false);

      if (data.runStatus === 'NOT_ENOUGH_FUNDS') {
        if (hasPermission('billing.team.edit') || hasPermission('billing.user')) {
          if (!promoStatus) {
            openNotEnoughFundsDialog();
          } else {
            showErrorNotification(
              'You do not have enough funds.',
              <RedirectToBilling redirect={redirect} />,
            );
          }
        } else {
          showErrorNotification(
            'You do not have enough funds. Please contact your team admin to add funds!',
          );
        }
        return;
      }
      redirect(`/jobs/${data.jobId}`);
    } catch (e) {
      console.log('ERROR', e);
    }
  };

  return (
    <LoadingButton
      // disabled={!isInQuantumWindow()}
      type="primary"
      variant="contained"
      onClick={handleClick}
      loadingPosition="end"
      endIcon={<div />}
      loading={isJobSubmitting}
      sx={{ paddingRight: '45px', paddingLeft: '45px' }}
    >
      Run Quantum
    </LoadingButton>
  );
};

const SampleQuantumJobButtonWithNotification = compose(
  withSignInDialog,
  withNotEnoughFundsDialog,
  withNotification,
)(SampleQuantumJobButton);

export default SampleQuantumJobButtonWithNotification;
